let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("2dfln"), load("5cXIN"), load("6gpUD")]).then(() => parcelRequire('dTw2J'));